import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    
    // Define redirect mappings for old routes to celebration routes
    const redirectMap: Record<string, string> = {
      '/home-old': '/',
      '/menu-old': '/menu',
      '/about-old': '/about',
      '/contact-old': '/contact',
      '/packages-old': '/packages',
      // Add any other legacy routes that should redirect
    };

    // Check if current path needs redirection
    if (redirectMap[path]) {
      navigate(redirectMap[path], { replace: true });
    }
  }, [location.pathname, navigate]);

  return null; // This component doesn't render anything
};

export default RedirectHandler;